import React, { useContext } from "react";
import { displayCurrency, displayFloat, formatPharmacyGroupName } from "../../utils/Helpers";
import { HORIZON } from "../../../constants/horizon";
import { PurchaseValidationContext } from "../PurchaseValidationContext";
import { Badge } from "../../common/Badge";
import { humanizeText } from "../../utils/StringFormatters";
import { Launch } from "@material-ui/icons";
import MixpanelService from "../../utils/MixpanelService";

export const AccountActionCard = ({ account, productPurchases }) => {
  const { setSubmitClaimsModal, coveredEntity340bId, purchaseValidationPath } =
    useContext(PurchaseValidationContext);

  const affectedAccount = account.affected_by_account;
  const affectingAccounts = account.affecting_accounts;

  const hasSuspendedAffectingAccount = affectingAccounts.find(
    (a) => a.display_status === "suspended"
  );

  let secondaryAccountDescHeader = null;
  let accountDescState = "default";

  if (affectedAccount) {
    secondaryAccountDescHeader = formatPharmacyGroupName(affectedAccount.group_name);
    accountDescState = "is_affected";
  } else if (affectingAccounts.length > 0) {
    secondaryAccountDescHeader = `Other Account(s) ${hasSuspendedAffectingAccount ? "Suspended" : "At Risk"}`;
    accountDescState = "is_affecting";
  }

  const accountDescResolver =
    HORIZON.ACCOUNT_DESC[account.display_status]?.[accountDescState] ?? (() => "");

  const accountDesc = accountDescResolver(
    formatPharmacyGroupName(
      (affectedAccount ?? affectingAccounts[0] ?? { group_name: "" }).group_name
    ),
    hasSuspendedAffectingAccount
  );

  return (
    <div className="action-card-wrapper mb-3">
      <div className="action-card account-details">
        <div className="row flex-grow-1">
          <div className="col col-6">
            <div className="t--500 t--md">Unvalidated Purchases</div>
            <div className="py-1 flex align-items-center gap--8">
              <span className="bold t--xl">{account.outstanding_purchase_count}</span>
              <span>({displayCurrency(account.outstanding_purchase_wac_value)} WAC)</span>
            </div>

            <div className="flex align-items-center gap--56 my-2 mr-5">
              <div>
                <div className="t--md t--500 my-1">Purchase Units</div>
                <div>
                  {displayFloat(
                    productPurchases.reduce(
                      (acc, product) => acc + parseFloat(product.purchase_unit_balance),
                      0
                    )
                  )}
                </div>
              </div>
              <div>
                <div className="t--md t--500 my-1">Claim Units</div>
                <div>
                  {displayFloat(
                    productPurchases.reduce(
                      (acc, product) => acc + parseFloat(product.claim_unit_balance),
                      0
                    )
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col col-6">
            {account.display_status !== "eligible" ? (
              <div className="flex justify-content-between align-items-center t--sm mb-3">
                <Badge color={HORIZON.STATUS_BADGE_COLOR[account.display_status] ?? "red"}>
                  {HORIZON.STATUS_NAME[account.display_status] ?? account.display_status}
                </Badge>
              </div>
            ) : null}

            <div className="t--500 t--md mb-2">
              {account.display_status === "eligible" &&
              !affectedAccount &&
              affectingAccounts.length == 0
                ? "Purchase Validation"
                : "Insufficient Claims"}
              {secondaryAccountDescHeader ? ` - ${secondaryAccountDescHeader}` : null}
            </div>

            <div className="t--sm t--secondary mb-3">{accountDesc}</div>
            <div className="flex align-items-center gap--8">
              {affectedAccount ? (
                <a
                  href={`${purchaseValidationPath}?account_id=${affectedAccount.id}&id_340b=${coveredEntity340bId}`}
                  target="_blank"
                >
                  <button style={{ height: 38 }} className="button button--white">
                    <Launch fontSize="small" />
                    Go to Account
                  </button>
                </a>
              ) : null}
              <button
                className="button button--white"
                onClick={() => {
                  MixpanelService.track("esp_horizon_ad_submit_claims");
                  setSubmitClaimsModal(true);
                }}
              >
                Submit Claims
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
